import "./zoom/jquery.exzoom";

jQuery(document).ready(function ($) {
  $(document).ready(function () {
    $("#exzoom").exzoom({
      // thumbnail nav options
      navWidth: 120,
      navHeight: 120,
      navItemNum: 5,
      navItemMargin: 7,
      navBorder: 1,

      // autoplay
      autoPlay: true,

      // autoplay interval in milliseconds
      autoPlayTimeout: 3000,
    });
  });
});
